export function toHumanDateTime(unixtimestamp){
    let date = new Date(unixtimestamp * 1000)
    let dd = date.getDate();
    dd = dd < 10 ? '0' + dd : dd;

    let mm = date.getMonth() + 1;
    mm = mm < 10 ? '0' + mm : mm;

    let yy = date.getFullYear() % 100;
    yy = yy < 10 ? '0' + yy : yy;

    let hh = date.getHours()
    hh = hh < 10 ? '0' + hh : hh;

    let mn = date.getMinutes()
    mn = mn < 10 ? '0' + mn : mn;

    return dd + '.' + mm + '.' + '20' + yy + ' ' + hh + ':' + mn
}